module.exports = __webpack_public_path__ + "static/media/logo.c049f19c.png";